import { Button, Flex, Text } from "@chakra-ui/react";
import { FaTimes } from "react-icons/fa";
import { crm } from "../../../theme";

export interface FilterChip {
  key: string;
  label: string;
  onRemove: () => void;
}

// Mostra os filtros ativos direto na tela — sem precisar abrir a modal pra saber o que está filtrando.
const ActiveFiltersBar = ({
  chips,
  onClear,
}: {
  chips: FilterChip[];
  onClear: () => void;
}) => {
  if (chips.length === 0) return null;

  return (
    <Flex flexWrap="wrap" gap="8px" align="center" mb="16px">
      {chips.map((chip) => (
        <Flex
          key={chip.key}
          align="center"
          gap="6px"
          bg={crm.brandSoft}
          color={crm.brand}
          border={`1px solid ${crm.brand}`}
          borderRadius="full"
          px="10px"
          py="5px"
          fontSize="12px"
          fontWeight="600"
          cursor="pointer"
          onClick={chip.onRemove}
          _hover={{ bg: crm.brand, color: "white" }}
          transition="all .12s ease"
        >
          <Text>{chip.label}</Text>
          <FaTimes size={9} />
        </Flex>
      ))}
      <Button
        size="xs"
        variant="ghost"
        color={crm.textMuted}
        fontWeight="600"
        borderRadius="full"
        textDecoration="underline"
        onClick={onClear}
        _hover={{ color: crm.text, bg: crm.subtle }}
      >
        Limpar filtros
      </Button>
    </Flex>
  );
};

export default ActiveFiltersBar;
